import React from 'react';
import PropTypes from 'prop-types';
var DisplayLine = function DisplayLine(_ref) {
  var title = _ref.title,
    value = _ref.value,
    className = _ref.className,
    testDisplay = _ref.testDisplay;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(className, " display-line")
  }, /*#__PURE__*/React.createElement("h5", {
    className: "display-line-title"
  }, title), /*#__PURE__*/React.createElement("p", {
    "data-test-element": testDisplay,
    className: "display-line-value"
  }, value));
};
DisplayLine.propTypes = {
  className: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  testDisplay: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
};
DisplayLine.defaultProps = {
  className: '',
  title: '',
  value: '',
  testDisplay: ''
};
export default DisplayLine;
//# sourceMappingURL=DisplayLine.js.map